import { render, staticRenderFns } from "./BalanceList.vue?vue&type=template&id=2596bf68"
import script from "./BalanceList.vue?vue&type=script&lang=js"
export * from "./BalanceList.vue?vue&type=script&lang=js"
import style0 from "./BalanceList.vue?vue&type=style&index=0&id=2596bf68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports